import React from 'react';
import { SelectorLabelRoot } from './style';
import { useComponentTheme } from '../../utils/hooks';
import selectorLabelDefaultTheme from './theme';
import { useSelectorLabelClassName } from './utils';
import { Typography } from '../Typography';
import { SELECTOR_LABEL_CLASS_PREFIX } from './constants';
export var SelectorLabel = function SelectorLabel(_ref) {
  var checked = _ref.checked,
      children = _ref.children,
      className = _ref.className,
      error = _ref.error,
      disabled = _ref.disabled,
      typographyProps = _ref.typographyProps;
  var theme = useComponentTheme(SELECTOR_LABEL_CLASS_PREFIX, selectorLabelDefaultTheme);
  var classOverride = useSelectorLabelClassName(SELECTOR_LABEL_CLASS_PREFIX, className, disabled, checked, error);
  return children ? React.createElement(SelectorLabelRoot, {
    disabled: disabled,
    error: error,
    className: classOverride.Root,
    theme: theme
  }, typographyProps ? React.createElement(Typography, Object.assign({
    disabled: disabled,
    error: error,
    margin: 0,
    theme: theme,
    tag: "div"
  }, typographyProps), children) : children) : null;
};
SelectorLabel.displayName = SELECTOR_LABEL_CLASS_PREFIX;